module.exports = __webpack_public_path__ + "img/icon-five.e2ae5f65.png";